import React from "react";

function NoDataIndication() {
  return (
    <>
      <div className="font-weight-bold mt-4">
        <span>NO RECORD FOUND</span>
      </div>
    </>
  );
}

export default NoDataIndication;
